export default __webpack_public_path__ + "static/media/info1.62ef1bfe.webp";